// extracted by mini-css-extract-plugin
export var noResults = "NoResultsCards-module--noResults--14969";
export var noResultsSub = "NoResultsCards-module--noResultsSub--a1721";